import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 rounded-catering-md border border-catering-cream-300 bg-catering-cream-50 p-3 text-sm shadow-catering-xs" }
const _hoisted_2 = {
  class: "flex h-7 w-7 shrink-0 items-center justify-center rounded-catering-sm bg-catering-lemon-100",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  key: 0,
  class: "text-xs text-catering-ink-500"
}

import { LightBulbIcon } from '@heroicons/vue/24/solid'


export default {
  __name: 'BotShortfallLogged',
  props: { block: { type: Object, required: true } },
  setup(__props) {



return (_ctx, _cache) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, [
      _createVNode(_unref(LightBulbIcon), { class: "h-4 w-4 text-catering-honey-500" })
    ]),
    _createElementVNode("div", null, [
      _cache[0] || (_cache[0] = _createElementVNode("p", { class: "font-semibold text-catering-ink-900" }, "Logged as a feature request", -1)),
      (__props.block.title)
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, _toDisplayString(__props.block.title), 1))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

}